import { Link, useNavigate } from 'react-router-dom';

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import { MenuItemType } from '../../components/types';
import { logout } from '../../data/firebase';

const MenuItem = ({ path, title, icon }: MenuItemType) => {
  const navigate = useNavigate();
  if (path === '/logout') {
    return (
      <ListItem
        key={path}
        disablePadding
        onClick={async () => {
          try {
            await logout();
            navigate('/login');
          } catch (error) {
            console.error('Failed to sign out...', error);
          }
        }}
      >
        <ListItemButton>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText sx={{ color: 'text.primary' }} primary={title} />
        </ListItemButton>
      </ListItem>
    );
  }
  return (
    <ListItem
      component={Link}
      state={{ title }}
      to={path}
      key={title}
      disablePadding
    >
      <ListItemButton>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText sx={{ color: 'text.primary' }} primary={title} />
      </ListItemButton>
    </ListItem>
  );
};

export default MenuItem;
